module.exports = __webpack_public_path__ + "static/media/delete_forever-24px.01754524.svg";